import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewButtonComponent } from '../../shared/components/new-button/new-button.component';
import { TableComponent } from '../../shared/components/table/table.component';
import { TaskService } from '../../core/services/task.service';
import { Task } from '../../core/models/task.model';
import { RouterModule } from '@angular/router';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { TaskDetailComponent } from '../task-detail/task-detail.component';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NewButtonComponent,
    TableComponent,
    RouterModule,
    ConfirmPopupComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    TaskDetailComponent,
  ],
})
export class TaskListComponent implements OnInit {
  tasks: Task[] = [];
  taskToDelete: Task | null = null;
  selectedTask: Task | null = null; // Para la tarea seleccionada
  tableColumns = [
    { header: 'ID', field: 'id' },
    { header: 'Nombre', field: 'name' },
    { header: 'Descripción', field: 'description' },
    { header: 'Estado', field: 'disabled' },
  ];

  constructor(private taskService: TaskService) {}

  ngOnInit(): void {
    this.getTasks();
  }

  getTasks(): void {
    this.taskService.getTasks().subscribe(tasks => {
      this.tasks = tasks;
    });
  }

  confirmDelete(task: Task): void {
    this.taskToDelete = task;
  }

  onDeleteConfirm(): void {
    if (this.taskToDelete && this.taskToDelete.id !== undefined) {
      this.taskService.deleteTask(this.taskToDelete.id).subscribe(() => {
        this.getTasks();
        this.taskToDelete = null;
      });
    }
  }

  onDeleteCancel(): void {
    this.taskToDelete = null;
  }

  toggleTaskStatus(task: Task): void {
    task.disabled = !task.disabled;
    this.taskService.disabledTask(task).subscribe(() => {
      this.getTasks();
    });
  }

  selectTask(task: Task): void {
    this.selectedTask = task; // Asigna la tarea seleccionada
  }

  closeTaskDetail(): void {
    this.selectedTask = null; // Cierra el detalle de la tarea
  }
}
